import Vue from 'vue';
import Vuex from 'vuex';

import userStorage from './plugins/userStorage';

import globals from './modules/globals';
import authorization from './modules/authorization';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [userStorage.plugin],
  modules: {
    globals,
    authorization
  }
});

export default store;
